// import * as Sentry from "@sentry/react";
// import { Integrations } from "@sentry/tracing";

export const catchError = (error: Error, info: { componentStack: string }) => {
    // Sentry.init({ dsn: "", integrations: [new Integrations.BrowserTracing()], tracesSampleRate: 1.0 });
    // Sentry.captureException(error);
    // Sentry.captureMessage(info.componentStack);
}